import { useState } from 'react';
import { formApi } from '../../services';

export const useDeleteForm = (
  tenantId: string,
  onDeleted: (formId: string) => void,
) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedFormId, setSelectedFormId] = useState<string | null>(null);
  const [deleting, setDeleting] = useState(false);

  const handleDeleteClick = (formId: string) => {
    setSelectedFormId(formId);
    setDeleteDialogOpen(true);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setSelectedFormId(null);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedFormId) return;
    setDeleting(true);
    try {
      await formApi.deleteForm(tenantId, selectedFormId);
      onDeleted(selectedFormId);
      setDeleteDialogOpen(false);
      setSelectedFormId(null);
    } catch (error) {
      alert('Error deleting form. Please try again.');
    } finally {
      setDeleting(false);
    }
  };

  return {
    deleteDialogOpen,
    deleting,
    handleDeleteClick,
    handleDeleteCancel,
    handleDeleteConfirm,
  };
};
